// extracted by mini-css-extract-plugin
export default {"lapLocationsTitle":"lapLocationsTitle_lapLocationsTitle__RudPP","lapLocationsTitle__price":"lapLocationsTitle_lapLocationsTitle__price__LzXUc"};